var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"info-hearing-aid-detail"},[(_vm.hearingAidDetail)?_c('BoardDetail',{attrs:{"board-id":_vm.id,"board":_vm.hearingAidDetail,"list-path":"/information/hearing-aid"}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }